import { Capacitor } from '@capacitor/core'
import { HUB_CONNECTOR_ENVIRONMENT_IS_SWAGWORLD } from 'settings/hubConnectorEnvironment'

export const isSemiosClassicMigrationEnabled =
  !HUB_CONNECTOR_ENVIRONMENT_IS_SWAGWORLD && Capacitor.getPlatform() === 'web'
